/* eslint-disable import/prefer-default-export */
import t from './DPPModule.type';

import * as productDpp from '../../../../services/dpp.services';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';

const errMsg = 'Failed to fetch data';

export const fetchDppById = (devOrderId, dppId) => {
  return async (dispatch) => {
    try {
      const response = await productDpp.getDPPProductById(devOrderId, dppId);

      if (response.code === 200) {
        dispatch({
          type: t.FETCH_DPP_DATA_BY_ID,
          payload: response.data,
        });
      }
      return response;
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const saveProductDppById = (devOrderId, dppId, moduleData, translation, type, newValue) => {
  return async () => {
    try {
      const response = await productDpp.addDPPProductById(devOrderId, dppId, moduleData);
      if (response.code === 200 && !type) {
        const msg = translation(`PRODUCT_DPP.${response.message}`);
        toasterMsg(msg, 'success');
      } else if (response.code === 200 && type && !newValue) {
        const msg = translation('PRODUCT_DPP.DPP_PUBLISHED_SUCCESSFULLY');
        toasterMsg(msg, 'success');
      } else if (response.code === 200 && type && newValue) {
        const msg = translation('PRODUCT_DPP.DPP_PUBLISH_SUCCESSFULLY');
        toasterMsg(msg, 'success');
      }
      return response;
    } catch (error) {
      toasterMsg(errMsg, 'danger'); // Assuming toasterMsg is a function to display error messages
    }
  };
};

export const uploadProductDPPImage = (data, devOrderId, dppLibId) => async () => {
  try {
    const res = await productDpp.uploadProductDPPImageS3(data, devOrderId, dppLibId);
    if (res?.code === 200) {
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const UNMOUNT_DPP_MODULE = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_DPP_LIB_DATA,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const uploadDPPImage = (data) => async () => {
  try {
    const res = await productDpp.uploadDPPImageS3(data);
    if (res?.code === 200) {
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchMainProductDetails = (id) => async (dispatch) => {
  try {
    const res = await productDpp.getProductDetails(id);
    if (res?.code === 200) {
      await dispatch({ type: t.GET_PRODUCT_DETAILS, payload: res.data });
      return res.data;
    }
    if (res?.data?.errMsg) {
      toasterMsg(res.data.errMsg, 'danger');
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
  } catch (error) {
    console.log('error...', error);
    toasterMsg(error.toString(), 'danger');
  }
};

export const fetchFactoryDetails = (data) => async (dispatch) => {
  try {
    const res = await productDpp.getALLFactoryDetails(data);
    if (res?.code === 200) {
      await dispatch({ type: t.GET_FACTORIES_DETAIL, payload: res.data });
      return res.data;
    }
    if (res?.data?.errMsg) {
      toasterMsg(res.data.errMsg, 'danger');
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
  } catch (error) {
    console.log('error...', error);
    toasterMsg(error.toString(), 'danger');
  }
};

export const fetchDPPBom = (devOrderId, params) => async (dispatch) => {
  try {
    const res = await productDpp.fetchProductBOM(devOrderId, params);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: t.GET_DPP_BOM,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchDPPBomProductJourney = (devOrderId, params) => async (dispatch) => {
  try {
    const res = await productDpp.fetchProductBOM(devOrderId, params);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: t.FETCH_SELECTED_BOM_DATA,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(err, 'danger');
  }
};

export const refreshDppControl = (devOrderId, dppLibId) => async () => {
  try {
    const res = await productDpp.refreshDppControl(devOrderId, dppLibId);
    if (res?.code === 200 && res.data) {
      toasterMsg(res.data.message, 'success');
      return res;
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const refreshControlPlusValue = (devOrderId, dppLibId) => async () => {
  try {
    const res = await productDpp.refreshControlPlusValue(devOrderId, dppLibId);
    if (res?.code === 200 && res.data) {
      toasterMsg(res.data.message, 'success');
      return res;
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};
